export default "__VITE_ASSET__JP55wbW0__"